import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GameStoreDispatcher } from 'src/app/core/state/game/game.dispatcher';
import { ComponentToLoad, GameStateId } from 'src/app/core/state/game/game.state';
import { SplitScreenService } from 'src/app/game/splitScreen.service';

@Component({
    selector: 'app-game-box',
    templateUrl: './game-box.component.html',
    styleUrls: ['./game-box.component.scss'],
    standalone: false
})
export class GameBoxComponent implements OnInit {
    showGameBox$: Observable<number>;
    gamesList$: Observable<ComponentToLoad[]>;
    selectedGame$: Observable<GameStateId>;

    constructor(
        private splitScreenService: SplitScreenService,
        private gameStoreDispatcher: GameStoreDispatcher
    ) {}

    ngOnInit() {
        this.showGameBox$ = this.gameStoreDispatcher
            .getState()
            .pipe(
                map((gameState) => {
                    return gameState.gamesList.filter(game => game.componentType === 'game' && !game.toNav || game.componentType !== "game").length;
                }),
            );

        this.gamesList$ = this.splitScreenService.gamesList$;

        this.selectedGame$ = this.splitScreenService.selectedGame$;
    }

    gameClicked(game: ComponentToLoad) {
        this.gameStoreDispatcher.addNewGame(game, true);
    }
}
